import React, { useEffect } from "react";
import { Container, Card, Row, Col } from "react-bootstrap";
import AOS from "aos";

const PrivacyPolicy = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <div className="py-5" style={{ backgroundColor: "#f8fbff" }}>
      <Container className="py-5">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="display-5 fw-bold mb-4" style={{ color: "#0B2E59" }}>
            Privacy Policy
          </h2>
          <div
            className="mx-auto mb-4"
            style={{
              width: "80px",
              height: "4px",
              background: "linear-gradient(90deg, #1D65A6 0%, #72A2C0 100%)",
              borderRadius: "2px",
            }}
          ></div>
          <p className="lead text-muted">
            Effective Date: June 11, 2026 | Last Updated: June 11, 2026
          </p>
        </div>

        <Card className="border-0 shadow-lg rounded-4 p-4 p-md-5" data-aos="fade-up" data-aos-delay="100">
          <Card.Body>
            <p>
              Welcome to <strong>The Innovative Solutions</strong>. We are committed to protecting the privacy, confidentiality, and security of our clients, website visitors, business partners, and users. This Privacy Policy explains how we collect, use, store, process, disclose, and protect your information when you access our website, products, applications, and services.
            </p>
            <p>
              By accessing or using our website, you acknowledge that you have read, understood, and agreed to the practices described in this Privacy Policy.
            </p>
            
            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>1. About The Innovative Solutions</h4>
            <p>The Innovative Solutions is a technology company providing services including but not limited to:</p>
            <ul>
              <li>Website Development</li>
              <li>Mobile Application Development</li>
              <li>Software Development</li>
              <li>Cloud Solutions</li>
              <li>Cybersecurity Services</li>
              <li>Digital Marketing</li>
              <li>UI/UX Design</li>
              <li>IT Consulting</li>
              <li>Technical Support & Maintenance</li>
              <li>Custom Enterprise Solutions</li>
            </ul>

            <h4 className="fw-bold mt-5" style={{ color: "#1D65A6" }}>2. Information We Collect</h4>
            
            <h5 className="mt-3">2.1 Personal Information</h5>
            <p>We may collect personal information directly from users, including:</p>
            <ul>
              <li>Full Name</li>
              <li>Company Name</li>
              <li>Business Information</li>
              <li>Email Address</li>
              <li>Phone Number</li>
              <li>Address</li>
              <li>Job Title</li>
              <li>GST Number (where applicable)</li>
              <li>Billing Information</li>
              <li>Project Requirements</li>
              <li>Communication Records</li>
            </ul>

            <h5 className="mt-3">2.2 Technical Information</h5>
            <p>We automatically collect technical information including:</p>
            <ul>
              <li>IP Address</li>
              <li>Browser Type and Version</li>
              <li>Device Information</li>
              <li>Operating System</li>
              <li>Screen Resolution</li>
              <li>Device Identifier</li>
              <li>Internet Service Provider Information</li>
              <li>Geographic Location (Approximate)</li>
              <li>Language Preferences</li>
              <li>Time Zone Settings</li>
            </ul>

            <h5 className="mt-3">2.3 Website Usage Information</h5>
            <p>We may collect:</p>
            <ul>
              <li>Pages Visited</li>
              <li>Clickstream Data</li>
              <li>Session Duration</li>
              <li>Navigation Patterns</li>
              <li>Referring URLs</li>
              <li>Exit Pages</li>
              <li>Download Activities</li>
              <li>Search Queries</li>
            </ul>

            <h5 className="mt-3">2.4 Project Information</h5>
            <p>For service delivery purposes, we may collect:</p>
            <ul>
              <li>Project Documentation</li>
              <li>Source Code</li>
              <li>Design Files</li>
              <li>Server Credentials</li>
              <li>API Credentials</li>
              <li>Database Access Information</li>
              <li>Business Workflows</li>
              <li>Technical Architecture Information</li>
            </ul>
            <p><em>All project-related information is treated as confidential.</em></p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>3. Legal Basis for Data Processing</h4>
            <p>We process information based on:</p>
            <ul>
              <li>User Consent</li>
              <li>Contractual Obligations</li>
              <li>Legal Compliance Requirements</li>
              <li>Legitimate Business Interests</li>
              <li>Security and Fraud Prevention Requirements</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>4. Purpose of Information Collection</h4>
            <Row>
              <Col md={6}>
                <h6 className="mt-3 fw-bold">Service Delivery</h6>
                <ul>
                  <li>Website Development</li>
                  <li>Mobile Application Development</li>
                  <li>Software Deployment</li>
                  <li>Technical Support</li>
                  <li>Cloud Infrastructure Management</li>
                </ul>
              </Col>
              <Col md={6}>
                <h6 className="mt-3 fw-bold">Business Operations</h6>
                <ul>
                  <li>Client Communication</li>
                  <li>Quotation Preparation</li>
                  <li>Project Management</li>
                  <li>Invoice Generation</li>
                  <li>Contract Execution</li>
                </ul>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <h6 className="mt-3 fw-bold">Website Improvement</h6>
                <ul>
                  <li>Analytics</li>
                  <li>Performance Monitoring</li>
                  <li>User Experience Enhancement</li>
                  <li>Security Monitoring</li>
                </ul>
              </Col>
              <Col md={6}>
                <h6 className="mt-3 fw-bold">Marketing</h6>
                <ul>
                  <li>Service Updates</li>
                  <li>Promotional Communications</li>
                  <li>Newsletter Distribution</li>
                  <li>Event Announcements</li>
                </ul>
              </Col>
            </Row>
            <p className="text-muted"><small>Users may opt out of marketing communications at any time.</small></p>

            <hr className="my-5" />

            <div className="text-center mb-5 mt-5">
              <h3 className="fw-bold mb-4" style={{ color: "#0B2E59" }}>
                Technical Data Collection & Security Policies
              </h3>
              <div
                className="mx-auto"
                style={{
                  width: "60px",
                  height: "3px",
                  background: "linear-gradient(90deg, #1D65A6 0%, #72A2C0 100%)",
                  borderRadius: "2px",
                }}
              ></div>
            </div>

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>5. Technical Data Collection and Security Policies</h4>
            <h5 className="mt-3">5.1 Server Log Policy</h5>
            <p>Our servers automatically maintain logs containing:</p>
            <ul>
              <li>IP Addresses</li>
              <li>Request Information</li>
              <li>Error Logs</li>
              <li>Access Timestamps</li>
              <li>Browser Information</li>
              <li>Security Events</li>
            </ul>
            <p>These logs are used for System Monitoring, Security Analysis, Troubleshooting, Fraud Detection, and Compliance Auditing.</p>

            <h5 className="mt-3">5.2 Cookie Policy</h5>
            <p>We use cookies and similar technologies including:</p>
            <ul>
              <li><strong>Essential Cookies:</strong> Required for Authentication, Session Management, Security Protection, and Form Submissions.</li>
              <li><strong>Analytics Cookies:</strong> Used to Analyze User Behavior, Improve Performance, and Generate Website Statistics.</li>
              <li><strong>Marketing Cookies:</strong> Used for Campaign Tracking, Advertisement Optimization, and User Engagement Analysis.</li>
            </ul>
            <p>Users can disable cookies through browser settings.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>6. Cybersecurity and Information Security Policies</h4>
            <p>The Innovative Solutions follows industry-standard security measures.</p>
            <Row className="mt-3">
              <Col md={6}>
                <h6>Network Security</h6>
                <ul>
                  <li>Firewall Protection</li>
                  <li>Intrusion Detection Systems</li>
                  <li>DDoS Protection</li>
                  <li>Traffic Monitoring</li>
                </ul>
              </Col>
              <Col md={6}>
                <h6>Application Security</h6>
                <ul>
                  <li>Secure Development Practices</li>
                  <li>Input Validation</li>
                  <li>Data Encryption</li>
                  <li>Vulnerability Assessments</li>
                </ul>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={6}>
                <h6>Infrastructure Security</h6>
                <ul>
                  <li>SSL/TLS Encryption</li>
                  <li>Secure Hosting Environment</li>
                  <li>Backup Systems</li>
                  <li>Disaster Recovery Mechanisms</li>
                </ul>
              </Col>
              <Col md={6}>
                <h6>Access Control</h6>
                <ul>
                  <li>Role-Based Access Control (RBAC)</li>
                  <li>Multi-Factor Authentication</li>
                  <li>Strong Password Policies</li>
                  <li>Restricted Administrative Access</li>
                </ul>
              </Col>
            </Row>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>7. Data Encryption Policy</h4>
            <h5 className="mt-3">Data in Transit</h5>
            <p>All communication between users and our systems is protected using HTTPS and SSL/TLS Encryption.</p>
            <h5 className="mt-3">Data at Rest</h5>
            <p>Sensitive information may be encrypted using industry-standard encryption methods.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>8. Source Code and Project Confidentiality Policy</h4>
            <p>Any source code, designs, documentation, credentials, or project information shared with The Innovative Solutions shall remain confidential.</p>
            <p>We commit to:</p>
            <ul>
              <li>Protect client intellectual property</li>
              <li>Restrict access to authorized personnel only</li>
              <li>Prevent unauthorized disclosure</li>
              <li>Maintain confidentiality agreements where applicable</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>9. Third-Party Services</h4>
            <p>We may use third-party services including Cloud Hosting Providers, Payment Gateways, Analytics Platforms, CRM Systems, Email Service Providers, and Communication Platforms.</p>
            <p>Examples may include Google Analytics, Google Cloud, AWS, Microsoft Azure, Razorpay, Cashfree, and Stripe. Third-party providers operate under their own privacy policies.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>10. Data Sharing Policy</h4>
            <p>We do not sell personal information. Information may only be shared with:</p>
            <ul>
              <li><strong>Authorized Personnel:</strong> Employees and contractors involved in service delivery.</li>
              <li><strong>Service Providers:</strong> Hosting providers, payment processors, and technical partners.</li>
              <li><strong>Legal Authorities:</strong> When required by law, court order, or government regulations.</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>11. Data Retention Policy</h4>
            <p>Information is retained only as long as necessary for Project Delivery, Contract Compliance, Legal Obligations, Security Investigations, and Financial Record Maintenance. After expiration of retention periods, data may be securely deleted or anonymized.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>12. Backup and Disaster Recovery Policy</h4>
            <p>To ensure service continuity, we maintain Regular Data Backups, Automated Backup Schedules, Redundant Infrastructure, and Disaster Recovery Procedures.</p>
            <p>However, no backup system can guarantee absolute protection against all forms of data loss.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>13. User Rights</h4>
            <p>Users may request:</p>
            <ul>
              <li>Access to Personal Data</li>
              <li>Data Correction</li>
              <li>Data Deletion</li>
              <li>Processing Restrictions</li>
              <li>Data Portability</li>
              <li>Withdrawal of Consent</li>
            </ul>
            <p>Requests can be submitted through our contact channels.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>14. Children's Privacy</h4>
            <p>Our services are intended for users aged 18 years and above. We do not knowingly collect information from children under 18 years of age. If such information is discovered, appropriate deletion procedures will be initiated.</p>

            <hr className="my-4" />
            
            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>15. International Data Transfers</h4>
            <p>Where necessary, data may be processed or stored on servers located outside India. By using our services, users consent to such transfers subject to applicable legal safeguards.</p>
            
            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>16. Compliance and Regulatory Policies</h4>
            <p>The Innovative Solutions strives to comply with:</p>
            <ul>
              <li>Digital Personal Data Protection Act (DPDP Act), 2023 (India)</li>
              <li>Information Technology Act, 2000</li>
              <li>Information Technology Rules, India</li>
              <li>Applicable Cybersecurity Regulations</li>
              <li>Industry Best Practices</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>17. Limitation of Liability</h4>
            <p>While we implement reasonable security measures, no online system can be guaranteed to be 100% secure.</p>
            <p>The Innovative Solutions shall not be liable for Unauthorized Access, Cyber Attacks, Force Majeure Events, Internet Service Failures, or Third-Party Security Breaches, except where required by applicable law.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>18. Changes to This Privacy Policy</h4>
            <p>We reserve the right to update this Privacy Policy at any time. Updated versions will be published on this page with the revised effective date. Continued use of our website constitutes acceptance of such changes.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>Contact Us</h4>
            <p>If you have any questions regarding this Privacy Policy or our data practices, please contact us:</p>
            <address>
              <strong>The Innovative Solutions</strong><br />
              Email: <a href="mailto:info@theinnovativesolutions.in">info@theinnovativesolutions.in</a><br />
              Website: <a href="https://www.theinnovativesolutions.in" target="_blank" rel="noreferrer">www.theinnovativesolutions.in</a><br />
              Phone: +91 95457 32392<br />
            </address>

            <div className="alert alert-info mt-4" role="alert">
              <strong>GDPR/DPDP Compliance:</strong> The Innovative Solutions complies with applicable data protection laws, including the Digital Personal Data Protection Act (DPDP Act), 2023 of India, and other applicable privacy regulations where required.
            </div>

          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
